import { Box, Select, Stack, Typography, theme } from '@dtx-company/design-system/src'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { useBuyPlanPageContext } from '../../context/useBuyPlanPageContext'
import React from 'react'

function createSeatOptions(
  minQuantity: number,
  maxQuantity: number
): { label: string; value: string }[] {
  const options = Array.from({ length: maxQuantity - minQuantity + 1 }, (_, index) => ({
    label: (minQuantity + index).toString(),
    value: (minQuantity + index).toString()
  }))
  return options
}

export const BuyPlanPageAdditionalSeats: React.FC = () => {
  const {
    document,
    planExtraSeatsDetails,
    setAdditionalSeatsQuantity,
    planExtraAdditionalSeats: planExtra,
    showPlanExtras
  } = useBuyPlanPageContext()
  const { data } = document

  if (!showPlanExtras) return null

  return (
    <Box sx={{ my: theme.spacing(12) }}>
      {data.additional_seats_heading && (
        <Typography variant="headlineXSmall" component="h2">
          {data.additional_seats_heading}
        </Typography>
      )}
      <Stack direction="row" justifyContent={'space-between'} sx={{ mt: theme.spacing(4) }}>
        {data.additional_seats_description && (
          <Box sx={{ width: '60%' }}>
            <Typography variant="bodyMedium">{data.additional_seats_description}</Typography>
          </Box>
        )}
        <Box>
          {planExtra?.minQuantity && planExtra?.maxQuantity && (
            <Select
              hiddenLabel
              label={data.additional_seats_heading || ''}
              defaultValue={planExtra.currentQuantity}
              value={
                planExtraSeatsDetails ? planExtraSeatsDetails.quantity : planExtra.currentQuantity
              }
              size="small"
              options={createSeatOptions(planExtra.minQuantity, planExtra.maxQuantity)}
              onChange={e => {
                setAdditionalSeatsQuantity(parseInt(e.target.value))
                fireAnalyticsEvent('BuyPlanPage_PlanExtras_Changed', {
                  type: planExtra.planExtraType,
                  value: e.target.value
                })
              }}
              onOpen={() => {
                fireAnalyticsEvent('BuyPlanPage_PlanExtras_Toggled', {
                  type: planExtra?.planExtraType,
                  open: true
                })
              }}
              onClose={() => {
                fireAnalyticsEvent('BuyPlanPage_PlanExtras_Toggled', {
                  type: planExtra?.planExtraType,
                  open: false
                })
              }}
              fullWidth
            />
          )}
        </Box>
      </Stack>
    </Box>
  )
}
